import React, { useEffect, useState } from "react";
import "./Home.css";

const Home = () => {
  const villageName = "मानोरा";

  const sarpanch = {
    name: "श्री. नंदकिशोर नत्थुजी तिवाडे",
    photo: "/images/sarpanch.jpeg",
  };

  const upsarpanch = {
    name: "श्री. भीमराव केवडराम गजभिये",
    photo: "/images/upsarpanch.jpeg",
  };

  const members = [
    { sr: 1, name: "श्री. कैलास डोमाजी ठाकरे", ward: "सदस्य", phone: "8999028296" },
    { sr: 2, name: "श्री. मिथुन जीवन माटे", ward: "सदस्य", phone: "9270096164" },
    { sr: 3, name: "सौ. शिल्पा सोमेश्वर गुडधे", ward: "सदस्य", phone: "8788565341" },
    { sr: 4, name: "सौ. सपना दिनेश लुटे", ward: "सदस्य", phone: "9763675857" },
    { sr: 5, name: "सौ. वनमाला संतोष फुलझेले", ward: "सदस्य", phone: "9021130483" },
    { sr: 6, name: "सौ. लेणेश्वरी मित्रजित मेश्राम", ward: "सदस्य", phone: "9370730457" },
  ];

  const heroImages = [
    "/images/img3.jpeg",
    "/images/img4.jpeg",
    "/images/img5.jpeg",
    "/images/img6.jpeg",
  ];

  const SafeImage = ({ src, alt }) => {
    const fallback = "https://via.placeholder.com/1200x700/138808/ffffff?text=मानोरा+गाव";
    const [imgSrc, setImgSrc] = useState(src);

    return (
      <img
        src={imgSrc}
        alt={alt}
        onError={() => setImgSrc(fallback)}
        className="hero-img"
      />
    );
  };

  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroImages.length);
    }, 6000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="home-page">
      {/* Marquee */}
      <div className="marquee-container">
        <div className="marquee">
          ग्रामपंचायत मानोरा | पंचायत समिती भिवापूर, जि. नागपूर | संपर्क: 8999028296 / 7972382206
        </div>
      </div>

      {/* Hero Slider */}
      <section className="hero">
        <div className="slider">
          {heroImages.map((img, index) => (
            <div
              key={index}
              className={`slide ${index === currentSlide ? "active" : ""}`}
            >
              <SafeImage src={img} alt={`मानोरा ${index + 1}`} />
            </div>
          ))}
        </div>

        <div className="hero-content">
          <h1 className="hero-title">स्वागत आहे!</h1>
          <p className="hero-subtitle">
            गट ग्रामपंचायत मानोरा - प्रगती, पारदर्शकता आणि विकासाचा संकल्प
          </p>
        </div>

        <div className="slider-controls">
          {heroImages.map((_, index) => (
            <button
              key={index}
              className={`dot ${index === currentSlide ? "active" : ""}`}
              onClick={() => setCurrentSlide(index)}
            />
          ))}
        </div>
      </section>

      {/* प्रतिनिधी सेक्शन - Left: Photos | Right: Table */}
      <section className="leaders-section">
        <h2 className="section-title">ग्रामपंचायत प्रतिनिधी</h2>
        
        <div className="leaders-layout">
          {/* Left Side - सरपंच + उपसरपंच */}
          <div className="leaders-left">
            <div className="leader-card sarpanch">
              <div className="leader-photo">
                <SafeImage src={sarpanch.photo} alt="सरपंच" />
              </div>
              <h3>सरपंच</h3>
              <p>{sarpanch.name}</p>
              <a href="/sarpanch" className="info-link">अधिक माहिती →</a>
            </div>

            <div className="leader-card upsarpanch">
              <div className="leader-photo">
                <SafeImage src={upsarpanch.photo} alt="उपसरपंच" />
              </div>
              <h3>उपसरपंच</h3>
              <p>{upsarpanch.name}</p>
              <a href="/upsarpanch" className="info-link">अधिक माहिती →</a>
            </div>
          </div>

          {/* Right Side - Members Table */}
          <div className="leaders-right">
            <div className="members-table">
              <table>
                <thead>
                  <tr>
                    <th>अ.क्र.</th>
                    <th>नाव</th>
                    <th>पद</th>
                    <th>संपर्क</th>
                  </tr>
                </thead>
                <tbody>
                  {members.map((member) => (
                    <tr key={member.sr}>
                      <td>{member.sr}</td>
                      <td>{member.name}</td>
                      <td>{member.ward}</td>
                      <td>{member.phone || "-"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>

      {/* Map */}
      <section className="map-section">
        <h2 className="section-title">आमचे स्थान</h2>
        <div className="map-wrapper">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1920.4780546646355!2d79.40516115200607!3d20.794706191232148!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a2b5514288f3ff7%3A0x7cb8444482cf0be!2sManora%2C%20Maharashtra%20441203%2C%20India!5e1!3m2!1sen!2sus!4v1769841398163!5m2!1sen!2sus"
            width="100%"
            height="500"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="मानोरा ग्रामपंचायत"
          ></iframe>
        </div>
      </section>
    </div>
  );
};

export default Home;